import * as React from "react";
import type { SVGProps } from "react";
const SvgSpotify = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#spotify_svg__a)">
      <path d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20m0-18a8 8 0 1 0 0 16 8 8 0 0 0 0-16" />
      <path d="M15.5 13.5a1 1 0 0 1-.6-.2 5.87 5.87 0 0 0-6.39-.47 1 1 0 0 1-1-1.72 7.89 7.89 0 0 1 8.61.59 1 1 0 0 1-.62 1.8" />
      <path d="M14 16.5a1 1 0 0 1-.83-.45c-.66-1-2.53-.94-3.62-.22a1 1 0 1 1-1.1-1.66c1.91-1.28 5-1.22 6.38.78a1 1 0 0 1-.28 1.38.94.94 0 0 1-.55.17M17 10.5a1 1 0 0 1-.53-.15 9.23 9.23 0 0 0-9-.46 1 1 0 0 1-.9-1.78 11.23 11.23 0 0 1 11 .54 1 1 0 0 1 .28 1.35 1 1 0 0 1-.85.5" />
    </g>
    <defs>
      <clipPath id="spotify_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSpotify;
